import { MINIMUM_INTERVAL_THRESHOLD_MS } from './MINIMUM_INTERVAL_THRESHOLD_MS';

/**
 * Determines whether a dead air interval should be excluded from tracking.
 *
 * Small intervals occur when multiple events arrive in rapid succession, e.g., a research title
 * followed immediately by research content as separate messages. For the end user, these appear
 * near-instantly. Additionally, DOM changes within such short intervals are imperceptible to the
 * human eye, and the interval is short enough to not affect subsequent dead air calculations.
 */
export const shouldExcludeInterval = (intervalMs: number): boolean => {
	return intervalMs <= MINIMUM_INTERVAL_THRESHOLD_MS;
};
